import './index.css';
import { useState, useEffect } from "react";
import { SessionAuth } from "supertokens-auth-react/recipe/session";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { EmailPasswordPreBuiltUI } from 'supertokens-auth-react/recipe/emailpassword/prebuiltui';
import { EmailVerificationPreBuiltUI } from "supertokens-auth-react/recipe/emailverification/prebuiltui";
import { SuperTokensWrapper } from "supertokens-auth-react";
import { getSuperTokensRoutesForReactRouterDom } from "supertokens-auth-react/ui";
import * as reactRouterDom from "react-router-dom";
import Joyride, { STATUS } from 'react-joyride';

// import MainPage from "./components/MainPage";
import TwoColumnLayout from "./components/TwoColumnLayout";
import NewLandingPage from "./components/NewLandingPage";
import LandingPage from "./components/LandingPage";
import Navbar from './components/NavBar';
import Gallery from "./components/Gallery";
import MockupsPage from "./components/MockupsPage";
import PrintOptions from "./components/PrintOptions";
import ProductCatalogPage from "./components/ProductCatalogPage";
import ConfigureMockupPage from "./components/ConfigureMockupPage";
import ConfirmOrderPage from "./components/ConfirmOrderPage";
import PaymentPage from "./components/PaymentPage";
import PaymentSuccessPage from "./components/PaymentSuccessPage";
import OrderHistoryPage from "./components/OrderHistoryPage";
import OrderDetailsPage from "./components/OrderDetailsPage";
import AdminPage from "./components/AdminPage";
import RoleManagement from "./components/RoleManagement";
import AdminOrderManagement from "./components/AdminOrderManagement";
import OrderManagementPage from "./components/OrderManagementPage";
import { api, uploadImage } from "./apiClient";
import ReviewMockupPage from "./components/ReviewMockupPage"; // NEW IMPORT
import SchedulerStatusPage from "./components/SchedulerStatusPage";
import { TermsPage, PrivacyPolicyPage, RefundPolicyPage } from "./components/LegalPages";

import { landingTour } from "./components/tours/landing";
import { designTour } from "./components/tours/design";
import { galleryTour } from "./components/tours/gallery";
import { productsTour } from "./components/tours/products";
import { mockupsTour } from "./components/tours/mockups";
import { configureMockupTour } from "./components/tours/configureMockup";

const styles = ["Default", "Anime", "Cyberpunk", "Sketch"];

function AppContent() {
  const [prompt, setPrompt] = useState("");
  const [style, setStyle] = useState(styles[0]);
  const [model, setModel] = useState("local");
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGenerate = async () => {
    if (!prompt) {
      alert("Please enter a prompt first!");
      return;
    }
    setLoading(true);
    try {
      // Trying likely endpoint structure. If 404, user may need to correct.
      const response = await api.post('/generate-image', {
        prompt,
        style,
        model
      });
      console.log("Generate response:", response.data);
      if (response.data && response.data.image_url) {
        setImageUrl(response.data.image_url);
      } else if (response.data && response.data.imageUrl) {
        setImageUrl(response.data.imageUrl);
      } else if (response.data && response.data.url) {
        setImageUrl(response.data.url);
      }
    } catch (error) {
      console.error("Error generating image:", error);
      alert("Failed to generate image. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (file) => {
    setLoading(true);
    try {
      const response = await uploadImage(file);
      console.log("Upload response:", response);
      if (response && response.imageUrl) {
        setImageUrl(response.imageUrl);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Failed to upload image.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App font-sans">
      <Navbar />
      <Routes>
        {getSuperTokensRoutesForReactRouterDom(reactRouterDom, [EmailPasswordPreBuiltUI, EmailVerificationPreBuiltUI])}
        <Route path="/" element={<NewLandingPage />} />
        <Route path="/old-landing-page" element={<LandingPage />} />
        <Route path="/design" element={
          <TwoColumnLayout
            prompt={prompt}
            setPrompt={setPrompt}
            style={style}
            setStyle={setStyle}
            model={model}
            setModel={setModel}
            loading={loading}
            handleGenerate={handleGenerate}
            handleUpload={handleUpload}
            imageUrl={imageUrl}
            setImageUrl={setImageUrl}
            styles={styles}
          />
        } />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/mockups" element={<MockupsPage />} />
        <Route path="/products" element={<ProductCatalogPage />} />
        <Route path="/configure-mockup" element={<ConfigureMockupPage />} />
        <Route path="/print-options" element={<PrintOptions />} />
        <Route path="/confirm-order/:mockupId" element={<ConfirmOrderPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/orders" element={<OrderHistoryPage />} />
        <Route path="/orders/:orderId" element={<OrderDetailsPage />} />
        <Route path="/review-mockup/:mockupId" element={<ReviewMockupPage />} />
        <Route path="/test-protected-fe" element={
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Test Protected Route</h1>
            <button
              onClick={async () => {
                try {
                  const response = await api.get('/protected');
                  alert(JSON.stringify(response.data));
                } catch (error) {
                  alert("Error: " + error.message);
                  console.error("Error accessing protected route:", error);
                }
              }}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '20px'
              }}
            >
              Call Protected Backend
            </button>
          </div>
        } />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/roles" element={<RoleManagement />} />
        <Route path="/admin/orders" element={<AdminOrderManagement />} />
        <Route path="/admin/scheduler-status" element={<SessionAuth requireAuth={true}><SchedulerStatusPage /></SessionAuth>} />
        <Route path="/ordermanagement" element={<SessionAuth><OrderManagementPage /></SessionAuth>} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
      </Routes >
    </div >
  );
}

export default function App() {
  return (
    <SuperTokensWrapper>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </SuperTokensWrapper>
  );
}
